import React from 'react';

import { ComponentForm, useComponentsContext } from '../../../components/ParamComponents';
import { ISelectOption } from 'react-ocean-forms-bootstrap';
import { KomponentenStatusUtil, KomponentenTypUtil } from '../../../api';
import { RequestInfoForm, StatusForm } from '../../../components/Forms';
import { useFormContext } from 'react-ocean-forms';
import { ViewConfig } from '../../../components';
import { CreateWorkflow } from '../../../components/Common/CreateWorkflow';
import { KomponenteStatus } from '../../../generated/types';

interface ComponentNewEditFormProps {
  viewConfig: ViewConfig;
  updateWorkflow?: (workflow: CreateWorkflow) => void;
  componentStatus?: KomponenteStatus;
}

/**
 * @author Jungwirth
 */

export const ComponentNewEditForm: React.FC<ComponentNewEditFormProps> = ({
  viewConfig, updateWorkflow = () => {}, componentStatus
}: Readonly<ComponentNewEditFormProps>): JSX.Element | null => {
  const { componentType, setComponentType } = useComponentsContext();
  
  const form = useFormContext();

  form.registerListener('formChanges', (name, event, args) => {
    updateWorkflow(CreateWorkflow.CheckDuplicates);
  });

  const onHandleComponentSelect = (option: ISelectOption): void => {
    if(option) {
      const type = KomponentenTypUtil.getComponentTypeEnum(option.value);
      setComponentType(type);
      return;
    }
    setComponentType(undefined);
  }

  const componentTypeOption = KomponentenTypUtil.getOptionalComponentOptionForEnum(componentType);

  console.log('componentTypeOption', componentTypeOption, componentType, componentStatus);

  return (
    <React.Fragment>
      <ComponentForm
        componentType={componentTypeOption}
        onComponentTypeSelect={onHandleComponentSelect}
        componentStatus={componentStatus}
        viewConfig={viewConfig} />
      <RequestInfoForm
        name="anforderung"
        viewConfig={viewConfig.fields}
        disabled={componentType === undefined}/>
      <StatusForm
        name="status"
        label="status"
        right
        viewConfig={viewConfig}
        statusUtil={KomponentenStatusUtil}
        disabled={componentType === undefined}
      />
    </React.Fragment>
  );
};
